import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

export const itemContainerSelector = createSelector(rootSelector, state => state.itemContainer);
export const itemContainerMapSelector = createSelector(rootSelector, state => state.itemContainer.map);
